import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logoSiloam from "../../assets/logo_siloam.png";
import bg from "../../assets/bg_sos.jpg";
import imgHeader from "../../assets/header_sos.png";
import PopupAdd from "../../components/popup_add";
import PopupCheckData from "../../components/popup_check_data";

const PageHome = () => {
  const [showRegistration, setShowRegistration] = useState(false);
  const [showCheckData, setShowCheckData] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {}, []);

  const handleSuccessAdd = (data) => {
    setShowRegistration(false);
  };

  const handleCloseRegistration = () => {
    setShowRegistration(false);
  };

  const handleOpenRegistration = () => {
    setShowRegistration(true);
  };

  const handleOpenCheckData = () => {
    setShowCheckData(true);
  };

  const handleCloseCheckData = () => {
    setShowCheckData(false);
  };

  return (
    <>
      {showRegistration && (
        <PopupAdd
          onClose={() => handleCloseRegistration()}
          onSuccess={(data) => handleSuccessAdd(data)}
          gate="REGISTRASI"
        />
      )}

      {showCheckData && (
        <PopupCheckData
          onClose={() => handleCloseCheckData()}
          gate="CHECK YOUR TICKET"
        />
      )}

      <div className="relative w-full md:w-[500px] mx-auto h-screen flex flex-col justify-between items-center ">
        <img
          src={bg}
          className="absolute z-10 w-full h-full mx-auto object-cover"
          alt=""
        />

        <img
          src={imgHeader}
          className="absolute z-50 top-0 w-full object-contain mx-auto object-cover"
          alt=""
        />

        <div className="overflow-x-hidden z-10 relative flex flex-grow w-full h-auto justify-center items-center  px-5">
          <div className="flex flex-col justify-center items-center pb-20 w-full space-y-6">
            <img src={logoSiloam} className="w-[280px] mb-4" alt="" />

            <div className="text-[#fbda08] text-center font-bold mb-0 uppercase text-xl">
              <div className="mt-2">
                <div>
                  The 4<sup className="lowercase">th</sup> SILOAM
                </div>
                <div>ONCOLOGY SUMMIT</div>
              </div>

              <div className="font-bold text-sm mt-2">24-25 MAY 2024</div>

              <div className="text-[#fbda08] text-center normal-case font-normal mt-6">
                <div className="text-sm max-w-[280px]">
                  JW MARRIOT JAKARTA
                </div>
                <div className="text-sm max-w-[280px]">
                Jl. Mega Kuningan Barat No. 1&2 Kav.E.1.
                </div>
              </div>
            </div>

            <div></div>

            {/* <button
              disabled
              // onClick={() => handleOpenRegistration()}
              className="min-w-[240px] px-1 py-2 bg-transparent border-2 border-[#fbda08] rounded-lg text-[#fbda08]  font-bold"
            >
              <div className="text-red-500">REGISTRATION</div>
              <div className="text-sm text-red-500">Available Soon</div>
            </button> */}

            <button
              onClick={() => handleOpenRegistration()}
              className="min-w-[240px] px-1 py-2 bg-transparent border-2 border-[#fbda08] rounded-lg text-white  font-bold"
            >
              REGISTRATION
            </button>

            {/* <button
              onClick={() => handleOpenCheckData()}
              className="min-w-[240px] px-1 py-2 bg-transparent border-2 border-[#fbda08] rounded-lg text-[#fbda08]  font-bold"
            >
              <div className="text-green-500">CHECK YOUR TICKET</div>
            </button> */}

            {/* <div className=""></div> */}

            <button
              onClick={() => navigate("/event-info")}
              className="min-w-[240px] px-1 py-2 bg-transparent border-2 border-[#fbda08] rounded-lg text-white  font-bold"
            >
              EVENT INFO
            </button>

            <button
              onClick={() => navigate("/contact-us")}
              className="min-w-[240px] px-1 py-2 bg-transparent border-2 border-[#fbda08] rounded-lg text-white  font-bold"
            >
              CONTACT US
            </button>
          </div>
        </div>

       
      </div>
    </>
  );
};

export default PageHome;
